<payee-popup width="600px">
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="house"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.COFACE_MANUAL_PAYMENT.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.COFACE_MANUAL_PAYMENT.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  @if (dataLoading()) {
    <div class="flex hcenter init-spinner">
      <mat-progress-spinner
        diameter="100"
        color="accent"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  }

  @if (!dataLoading()) {
    <form
      [formGroup]="manualPaymentForm"
      (submit)="submit()"
    >
      <div class="payment-date-row">
        <payee-form-field
          width="max"
          height="taller"
        >
          <span payee-label>
            {{ "WORKFLOW_DIALOGS.COFACE_MANUAL_PAYMENT.PAYMENT_DATE_LABEL" | translate }}
          </span>
          <payee-datepicker
            formControlName="paymentDate"
            [max]="maxPaymentDate"
            [placeholder]="'WORKFLOW_DIALOGS.COFACE_MANUAL_PAYMENT.PAYMENT_DATE_PLACEHOLDER' | translate"
          ></payee-datepicker>
          @if (paymentDate.dirty) {
            <ng-container payee-error>
              @if (paymentDate.hasError("required")) {
                <mat-error>
                  {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                </mat-error>
              }
              @if (paymentDate.hasError("maxDate")) {
                <mat-error>
                  {{ "WORKFLOW_DIALOGS.COFACE_MANUAL_PAYMENT.PAYMENT_DATE_MAX" | translate }}
                </mat-error>
              }
            </ng-container>
          }
        </payee-form-field>
      </div>
      <div class="flex payment-amount-forms">
        <div class="grow1">
          <payee-form-field
            width="max"
            height="taller"
          >
            <input
              class="payment-amount"
              payee-input
              formControlName="paymentAmount"
            />
            @if (paymentAmount.dirty) {
              <ng-container payee-error>
                @if (paymentAmount.hasError("min")) {
                  <mat-error>
                    {{ "WORKFLOW_DIALOGS.MANUAL_PAYMENT.MIN_AMOUNT" | translate: { currency: currency.value } }}
                  </mat-error>
                }
                @if (paymentAmount.hasError("max")) {
                  <mat-error>
                    {{
                      "WORKFLOW_DIALOGS.MANUAL_PAYMENT.MAX_AMOUNT"
                        | translate
                          : {
                              max: paymentAmount.errors?.max?.max | number: "1.0" : "hu",
                              currency: currency.value,
                            }
                    }}
                  </mat-error>
                }
                @if (paymentAmount.hasError("required")) {
                  <mat-error>
                    {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                  </mat-error>
                }
              </ng-container>
            }
          </payee-form-field>
        </div>
        <payee-dropdown
          formControlName="currency"
          width="auto"
          height="taller"
          [options]="currencyOptions"
        ></payee-dropdown>
      </div>
      <div class="claim-details-container">
        @for (claim of dialogData.claims; track claimIndex; let claimIndex = $index) {
          <div class="claim-details flex vcenter">
            <div class="claim-number">
              {{ claimIndex + 1 }}.
              {{ "WORKFLOW_DIALOGS.MANUAL_PAYMENT.CLAIM" | translate }}
            </div>
            <div class="claim-name">{{ claim.claim_type_label }}</div>
            <div class="claim-value">
              {{ claimRemainingAmount(claim) | number: "1.0" : "hu" }}
              {{ claim.currency_iso }}
            </div>
          </div>
          @for (optionalClaim of claim.optional_claims; track optionalClaimIndex; let optionalClaimIndex = $index) {
            <div
              class="optional-claim-details flex vcenter"
              [class.is-paid]="claim.is_paid"
            >
              <div class="optional-claim-name">
                {{ optionalClaim.claim_type_label }}
              </div>
              <div class="optional-claim-value">
                {{ claimRemainingAmount(optionalClaim) | number: "1.0" : "hu" }}
                {{ claim.currency_iso }}
              </div>
            </div>
          }
        }
      </div>
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      class="payee-button"
      payee-button
      color="blue"
      width="max"
      height="normal"
      [disabled]="manualPaymentForm.invalid || loading"
      [loading]="loading"
      (click)="submit()"
    >
      @if (!isFullPayment) {
        {{ "WORKFLOW_DIALOGS.MANUAL_PAYMENT.SUBMIT" | translate }}
      } @else {
        {{ "WORKFLOW_DIALOGS.MANUAL_PAYMENT.FULL_PAYMENT" | translate }}
      }
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      mat-dialog-close
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.MANUAL_PAYMENT.CANCEL" | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
